import './App.css';
import { Plano } from './components/Plano/Plano';
import seloGarantia from './assets/images/selo-garantia-7-dias.png';
import fotoPerfilWesley from './assets/images/foto-perfil-wesley.png';
import selosCartoes from './assets/images/SELOS.png'
import { Bloco } from './components/Bloco/Bloco';
import { SanfonaModulos, SanfonaModulos11, SanfonaModulos14, SanfonaModulos4, SanfonaModulos6, SanfonaModulos8 } from './components/SanfonaModulos/SanfonaModulos';
import { Perguntas } from './components/Perguntas/Perguntas';
import { Botao } from './components/Botao/Botao';
import React from 'react';

import bonus1 from './assets/images/Bonus-1.png';
import bonus2 from './assets/images/Bonus-2.png';
import bonus3 from './assets/images/Bonus-3.png';
import bonus4 from './assets/images/Bonus-4.png';

export class App extends React.Component {

  render() {

    return (
      <>
        <header>
          <a href="#planos" className='link-header'><h2 className='titulo-header'>últimas vagas com 80% de desconto</h2></a>
        </header>
        <main>
          <section className='inicio'>
            <div className='inicio_container'>

              <div className='inicio_container-content flex-inicio'>
                <h1>Descubra o passo a passo definitivo para <span className='destaque'>dominar vibrato, notas AGUDAS e GRAVES e impressionar todos ao cantar</span> mesmo começando do ZERO e sem nenhum talento.</h1>

                <h4 className='inicio_subtitulo'>Você vai aprender meu Método exclusivo do ZERO!</h4>

                <Botao classBotao='inicio_botao btn btn-hover' link='#planos' textoBotao='Quero me inscrever' />
              </div>

              <div className='inicio_container-content video-inicio flex-inicio'>
                <iframe loading='lazy' src="https://www.youtube.com/embed/r0LNxunDBNY?si=h6ZJpnML6pmBlcu_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>

            </div>
          </section>

          <section className='target'>
            <div className='target_container'>

              <h2 className='section-title'>MARATONA <span className='destaque'>VOCAL 4.0</span> É PRA VOCÊ QUE...</h2>
              <div className='bloco-container'>
                <Bloco tituloBloco='não sabe cantar'
                  textoBloco='É um completo iniciante, mas quer começar a cantar do absoluto zero' />

                <Bloco tituloBloco='QUER SER PROFISSIONAL'
                  textoBloco='Não sabe as técnicas necessárias para construir uma carreira de sucesso, mas quer começar a jornada' />

                <Bloco tituloBloco='CANTA EM KARAOKÊ'
                  textoBloco='Quer cantar por hobby e sente que canta relativamente bem, mas precisa aprimorar para subir de nível' />

                <Bloco tituloBloco='JÁ É PROFISSIONAL'
                  textoBloco='É um cantor profissional e precisa melhorar sua técnica' />

                <Bloco tituloBloco='QUER SE DESTACAR'
                  textoBloco='Quer aprender cantar bem para impressionar todos ao cantar' />

                <Bloco tituloBloco='É PROFESSOR'
                  textoBloco='Já dá aulas de canto, mas sente que precisa melhorar seu desempenho' />

                <Bloco tituloBloco='PRECISA DE SUPORTE'
                  textoBloco="Você que sente que só vai aprender tendo suporte e acesso a áreas Vip's exclusivas" />

                <Bloco tituloBloco='QUER DIPLOMA'
                  textoBloco="Quer uma comprovação de que está apto para cantar em público e precisa de horas complementares" />

                <Bloco tituloBloco='QUER APRENDER TUDO'
                  textoBloco="Quer um cronograma montado e planejado para sua evolução com mais de 90 aulas gravadas em vídeos, PDF's e áudios de exercícios" />

                <Bloco tituloBloco='QUER ALGO PARA SAIR DO COMUM'
                  textoBloco="Precisa de um treinamento que além de te ensinar a cantar, te dá a possibilidade de aprender a tocar instrumentos (teclado, violão, ukulele)" />

                <Bloco tituloBloco='MENTORIA AO VIVO'
                  textoBloco="Quer te a oportunidade também de fazer parte dos Alunos Black, que terão direito a um ano de mentoria ao vivo no ZOOM - 24 aulas (OPCIONAL)" />

                <Bloco tituloBloco='QUER TEMPO PARA ESTUDAR'
                  textoBloco="Que tem a vida corrida e precisa de tempo para estudar de acordo com sua agenda e e cronograma" />
              </div>

              <a href="#planos" className='link-target'>
                <div className='fa-check-bg'>

                  <i className="fa-solid fa-check"></i>
                </div>

                <span>o curso é pra mim!</span>
              </a>
            </div>
          </section>

          <section className='section-modulos'>
            <div className='section-modulos_container'>

              <h2 className='section-title'>o que você vai <span className='titulo-span-modulos'>aprender:</span></h2>
              <div className='modulo_sanfona-container'>

                {/* MODULO 1 */}
                <SanfonaModulos4
                  tituloSanfona='Módulo 01: Comece por aqui'
                  moduloResposta1='Sobre o Curso - MÉTODO'
                  moduloResposta2='Preciso te Conhecer - Pesquisa Rápida'
                  moduloResposta3='Suporte, Áreas VIPs e Acessos'
                  moduloResposta4="Acessar os PDF's e Áudios" />

                {/* MODULO 2 */}
                <SanfonaModulos8
                  tituloSanfona='Módulo 02: O que não te contaram sobre sua voz'
                  moduloResposta1="Três F's - Processo Fonador"
                  moduloResposta2='Diafragma é um Músculo e NÃO ENCHE'
                  moduloResposta3='Exercício Respiratório - DESAFIO'
                  moduloResposta4="Laringe e Pregas Vocais"
                  moduloResposta5="Alimentos Para Cantar Bem"
                  moduloResposta6="Tirando Pigarro da Garganta - Shaker"
                  moduloResposta7="Hidratação Vocal - Parte 1"
                  moduloResposta8="Hidratação Vocal - Parte 2" />

                {/* MODULO 3 */}
                <SanfonaModulos6
                  tituloSanfona='Módulo 03: Cantar, uma atividade física'
                  moduloResposta1="Condicionamento Vocal Diário"
                  moduloResposta2='Aquecimento Vocal e Desaquecimento'
                  moduloResposta3='Aquecimento Vocal Antes das Apresentações'
                  moduloResposta4="Modos Respiratórios"
                  moduloResposta5="Tipos de Respiração"
                  moduloResposta6="Aplicando a Respiração" />

                {/* MODULO 4 */}
                <SanfonaModulos
                  tituloSanfona='Módulo 04: Mentoria Black - Análise Vocal - Suporte UpGrade'
                  moduloResposta1="Como Funciona a Mentoria Black" />

                {/* MODULO 5 */}
                <SanfonaModulos14
                  tituloSanfona='Módulo 05: Afinação, desafinação e tonalidade'
                  moduloResposta1="Os Pilares da Afinação"
                  moduloResposta2='Reproduzindo as Notas'
                  moduloResposta3='Decorando a Escala - Dó Si Dó'
                  moduloResposta4="DO SI DO"
                  moduloResposta5="Memória Musical - Escala Maior"
                  moduloResposta6="Escala Maior Ascendente"
                  moduloResposta7="Escala Maior Descendente"
                  moduloResposta8="Escala Maior Ascendente Alternada"
                  moduloResposta9="Escala Maior Descendente Alternada"
                  moduloResposta10="Memória Musical - Escala Cromática"
                  moduloResposta11="Escala Cromática - Ascendente"
                  moduloResposta12="Escala Cromática - Descendente"
                  moduloResposta13="Memória Musical - Escala Menor Natural"
                  moduloResposta14="Escala Menor Natural - Intercalando" />

                {/* MODULO 6 */}
                <SanfonaModulos6
                  tituloSanfona='Módulo 06: Timbre vocal'
                  moduloResposta1="Ressonância"
                  moduloResposta2='Articulação e Dicção'
                  moduloResposta3='Exercícios Mistos 1'
                  moduloResposta4="Nha Nha Nha"
                  moduloResposta5="Ressonância Fechada (^)"
                  moduloResposta6="Ressonância Aberta (´)" />

                {/* MODULO 7 */}
                <SanfonaModulos6
                  tituloSanfona='Módulo 07: Dinâmica de intensidade, soprosidade e interpretação'
                  moduloResposta1="Dinâmica de Intensidade"
                  moduloResposta2='Exercícios - Dinâmica de Intensidade'
                  moduloResposta3='Soprosidade'
                  moduloResposta4="Exercícios - Soprosidade"
                  moduloResposta5="Interpretação (parte 1)"
                  moduloResposta6="nterpretação (parte 2)" />

                {/* MODULO 8 */}
                <SanfonaModulos11
                  tituloSanfona='Módulo 08: Ornamentos e efeitos embelezadores'
                  moduloResposta1="Vibrato"
                  moduloResposta2='Vibrato - Exercício 1'
                  moduloResposta3='Vibrato - Exercício 2'
                  moduloResposta4="Apogiatura"
                  moduloResposta5="Exercício de Apogiatura Descendente"
                  moduloResposta6="Apogiaturas e Vibrato - Poderoso Deus"
                  moduloResposta7="Melisma"
                  moduloResposta8="Escala Maior - Ascendente e Descendente com O"
                  moduloResposta9="Escala Pentatônica Descendente Alternada 1"
                  moduloResposta10="Exercício Escala Pentatônica 2"
                  moduloResposta11="Aplicação" />

                {/* MODULO 9 */}
                <SanfonaModulos8
                  tituloSanfona='Módulo 09: Desenvolvendo agudos e graves'
                  moduloResposta1="Posso Alcançar Notas Agudas e Graves?"
                  moduloResposta2='Diferença Entre Extensão e Tessitura'
                  moduloResposta3='Registros Vocais'
                  moduloResposta4="Fry e Voz de Peito - Exercícios"
                  moduloResposta5="Falsete e Voz de Cabeça - Exercícios"
                  moduloResposta6="Voz Mista - Exercícios"
                  moduloResposta7="Como Baixar o Tom das Músicas"
                  moduloResposta8="Mind Vox" />
              </div>
            </div>
          </section>

          <section className='section-bonus'>
            <h2 className='section-title'>VOCÊ AINDA LEVA ESSES <span className='section-title destaque'>BÔNUS</span> SE <span className='section-title destaque'>COMPRAR HOJE</span>:</h2>
            <div className='bonus_imagens'>
              <img src={bonus1} alt="Bonus 1 RESPIRON & SHAKER Surpresa para alunos" />
              <img src={bonus2} alt="Bonus 2 POCKET Harmony Vox" />
              <img src={bonus3} alt="Bonus 3 CANTO CONSCIENTE Fonoaudiologia e Voz" />
              <img src={bonus4} alt="Bonus 4 10 MANEIRAS DE GANHAR Dinheiro com música" />
            </div>
            <Botao link='#planos' classBotao='bonus_botao btn btn-hover' textoBotao='QUERO OS BÔNUS' />
          </section>

          <section className='section-avaliacoes'>
            <div className='avaliacoes_container'>

              <ul className='star-container'>
                <li className='star'>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </li>
              </ul>

              <h2 className='section-title'>VEJA O QUE NOSSOS ALUNOS<br /> DIZEM SOBRE NOSSO CURSO</h2>
              <div className='avaliacoes_videos-container'>
                <iframe loading="lazy" src="https://www.youtube.com/embed/jfa1bb5H9jU?si=B12mKTe8Hkt33pB_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                <iframe loading="lazy" src="https://www.youtube.com/embed/NUmoC4l98CA?si=Z6243H-aVPSPEsWx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                <iframe loading="lazy" src="https://www.youtube.com/embed/fPNQy1QJ-AU?si=tCyx8rLHI2rCsZmz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                <iframe loading="lazy" src="https://www.youtube.com/embed/ux2FXutvUYo?si=hCUEu6tq1sRYy4yF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

              </div>

            </div>
          </section>

          <section id='planos' className='section-planos'>
            <h2 className='section-title'>TEMOS 2 PLANOS PARA VOCÊ ⬇️⬇️</h2>
            <h3 className='planos_subtitle'>Veja o plano que mais faz sentido para você (<span className='destaque planos_subtitle'>últimas vagas com 80% de desconto</span>)</h3>

            <div className='plano_container'>

              <Plano tituloPlano='UM ANO DE ACESSO'
                valorAntigo='3.085'
                valorAtual='19,80'
                aVista='187,00'
                textoFinal='um ano de acesso'
                linkPlano='https://pay.hotmart.com/M91272872D?off=nhn0wxsq&checkoutMode=10&src=null-null-null-null-null'
                textoBotao='comprar agora' />

              <Plano tituloPlano='FREE PASS VITALÍCIO ✅✅✅'
                valorAntigo='2.780'
                valorAtual='29,33'
                aVista='277,00'
                textoFinal='TODAS AS AULAS NOVAS QUE AINDA SERÃO CRIADAS'
                linkPlano='https://pay.hotmart.com/K91264409K?off=3fol8id9&checkoutMode=10&bid=1726857983040'
                textoBotao='free pass vitalício' />

            </div>
          </section>

          <section className='section-garantia'>
            <div className='garantia_container'>

              <img src={seloGarantia} alt="Selo da garantia" />

              <div className='garantia_content'>
                <h3>COMPRA GARANTIDA</h3>

                <span>Não gostou? Receba 100% do seu dinheiro de volta!</span>

                <p>
                  Ao participar do curso, você possui 7 dias de garantia incontestável, ou seja, se dentro de 7 dias após a compra você concluir que o método não é para você, é só enviar uma mensagem para suporte@177.154.191.198 que devolveremos 100% do seu dinheiro.
                </p>

                <span>Depois dessa garantia, a única atitude que você pode ter agora é clicar no botão verde.</span>
              </div>
            </div>
          </section>

          <section className='section-biografia'>
            <div className='biografia_container'>

              <img className='foto-wesley-desktop' src={fotoPerfilWesley} alt="Foto do Wesley Moreira" />

              <div className='biografia_content'>
                <h2 className='nome-biografia'>QUEM É <span className='destaque nome-biografia'>WESLEY MOREIRA</span>?</h2>

                <img className='foto-wesley-mobile' src={fotoPerfilWesley} alt="Foto do Wesley Moreira" />

                <p>
                  <span className='destaque biografia-destaque-span'>Wesley Moreira</span> é cantor, backing vocal, multi-instrumentista, professor de canto, arranjador e preparador vocal há mais de 11 anos, com certificações, especializações em várias áreas e graduando.
                </p>

                <ul>
                  <li>Graduando em Licenciatura em Música</li>
                  <li>Especialização em Voz Cantada</li>
                  <li>Epecialização em Harmonia Vocal</li>
                  <li>Graduando em Fonoaudiologia</li>
                  <li>Especialização em Fisiologia da Voz Cantada</li>
                  <li>Conservatório de Percussão</li>
                  <li>Conservatório de Flauta</li>
                </ul>

                <p>
                  Já atuou profissionalmente com <span className='destaque-branco'>Isadora Pompeo, Jessica Augusto, Jeová Nissi (Rua Azusa, musical gospel mais conhecido do Brasil), Soraya Moraes, Adhemar de Campos, Cantor PG</span> entre outros.
                </p>

                <p>
                  Hoje, sua maior missão é compartilhar o conhecimento que adquiriu durante anos, para que cada vez mais pessoas tenham acesso ao ensino de qualidade e alcancem seus objetivos vocais.
                </p>

                <p>
                  Sua maior alegria é poder ter a honra de já ter ajudado mais de <span className='destaque-branco'>150 mil pessoas</span> em suas redes sociais e mais de <span className='destaque-branco'>15 mil alunos</span> em seus treinamentos, espalhados em mais de <span className='destaque biografia-destaque-span'>30 países</span>.
                </p>
              </div>
            </div>
          </section>

          <section className='section-duvidas'>
            <div className='duvidas_container'>

              <h2>Perguntas Frequentes</h2>
              <div className='duvidas_sanfona-content'>
                <Perguntas
                  tituloSanfona='EM QUANTO TEMPO RECEBO ACESSO AO MARATONA VOCAL?'
                  duvidasResposta='Se você pagar via cartão de crédito, o seu acesso é imediato e via boleto o recebimento é em até 48 horas após o pagamento.' />
                <Perguntas
                  tituloSanfona='EU NÃO QUERO ME TORNAR UM CANTOR PROFISSIONAL, É PARA MIM?'
                  duvidasResposta='Pensa o seguinte: Imagina você chegar em uma imobiliária e falar que quer alugar uma kitnet 
                  de 1 quarto. Ai o corretor olha para você e fala: “Eu tenho algo melhor para você, com esse valor você consegue
                  comprar uma casa de 3 quartos com piscina e ainda na beira do mar”. O que você acharia disso? Incrível né! É 
                  mais ou menos isso que estamos te oferecendo. Você paga menos do que muitos cobram para te ensinar o básico, e
                  ainda leva um curso completo do básico ao avançado, bônus que te ajudaram a se profissionalizar e produzir sua
                  própria música, além de cursos com profissionais que te ajudarão em todos aspectos da sua forma de cantar, como
                  por exemplo, superar sua timidez.' />
                <Perguntas
                  tituloSanfona='EU JÁ SOU PROFISSIONAL, É PARA MIM?'
                  duvidasResposta='Quando se é um profissional você deve sempre buscar se aprimorar, mas o pior problema é que você
                  tem que pagar separadamente tudo que faz. Fez um curso de instrumento é um valor… fez um curso de controle vocal
                  mais outro valor… fez um curso de desenvolvimento emocional mais um valor… No Maratona Vocal você paga uma única
                  vez e receber tudo isso e muito mais de graça como bônus.' />
                <Perguntas
                  tituloSanfona="EU APRENDO A CANTAR MESMO ONLINE?"
                  duvidasResposta="Sim, a maioria das técnicas e conteúdo que aprendi foi online. Eu sou a prova viva de que se tiver
                  o método correto você aprende a cantar seja online ou não." />
                <Perguntas
                  tituloSanfona="E SE EU NÃO GOSTAR DO CONTEÚDO?"
                  duvidasResposta="Se você acha que impressionar todos ao contar não é o que você quer, não se preocupe, basta solicitar
                   o reembolso que devolvemos 100% do valor pago, imediatamente dentro do prazo de 7 dias da aquisição" />

                <Perguntas
                  tituloSanfona="TEREI ACESSO POR QUANTO TEMPO?"
                  duvidasResposta="Terá acesso durante o período em que pagar e/ou renovar as assinaturas. A renovação é automática, caso
                  não queira é só cancelar, antes de renovar a assinatura sem burocracia." />
              </div>
            </div>
          </section>

        </main>
        <footer>
          <span>® 2024 MARATONA VOCAL | TODOS OS DIREITOS RESERVADOS</span>
          <a target='_blank' href='https://portfolio-pauloadson.vercel.app/'> Desenvolvido por <span className='copy-footer'>Paulo Adson</span></a>
          <img src={selosCartoes} alt="Selo dos Cartões" />
        </footer>
      </>
    );
  }
}

export default App;
